
import { Component, Vue, Prop } from 'vue-property-decorator';
import { ModalidadCuotaI } from '@/assets/api/pagare';

@Component
export default class InformacionPago extends Vue {
  @Prop({ default: () => ({}) }) readonly detallesPeriodo!: any;
  @Prop({ default: 5 }) readonly modo!: number;
  @Prop({ default: null }) readonly modalidad!: number | null;
  @Prop({ default: () => [] }) readonly modalidadesCuotas!: ModalidadCuotaI[];
  @Prop({ default: null }) readonly modalidadCuota!: number | null;
  @Prop({ default: false }) readonly disabled!: boolean;

  get esMagister(): boolean {
    return this.$store.getters.esMagister;
  }

  get descargaPagareCarrera(): string {
    const linkBase = 'https://drive.google.com/uc?export=download&id=';
    const modalidadCuota = this.modalidadesCuotas.find(
      (modalidad) => modalidad.id === this.modalidadCuota,
    );
    return modalidadCuota ? `${linkBase}${modalidadCuota.link_pagare}` : '';
  }

  dia = (fecha: Date): string => fecha.toLocaleString('es-cl', { day: '2-digit' });
  mes = (fecha: Date): string => fecha.toLocaleString('es-cl', { month: 'long' });

  fecha(fecha: Date): string {
    return `${this.dia(fecha)} de ${this.mes(fecha)}`;
  }
}
